import { render, staticRenderFns } from "./Dashboard-comp.vue?vue&type=template&id=1a893a5b&scoped=true&"
import script from "./Dashboard-comp.vue?vue&type=script&lang=js&"
export * from "./Dashboard-comp.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard-comp.vue?vue&type=style&index=0&id=1a893a5b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a893a5b",
  null
  
)

export default component.exports